export default __webpack_public_path__ + "static/media/woodtxt.22d6f830.png";